import MovoFleetLogo from '@/shared/ui/branding/MovoFleetLogo';

export default function AuthBrand({ className = '' }: { className?: string }) {
  return (
    <header className={`flex items-center gap-3 ${className}`}>
      <MovoFleetLogo variant="auth" alt="" />
      <span className="text-section-title text-strong">Movo Fleet</span>
    </header>
  );
}
